import React from 'react';
import contact1 from '../images/contact1.png';
import linked_in_icon from '../images/linkedin.svg';
import facebook_icon from '../images/github-mark.png';
import instagram_icon from '../images/instagram.svg';

function Contact() {
    return (
        <div className="rn-contact-area rn-section-gap section-separator" id="contacts">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span className="subtitle">Get in Touch</span>
                            <h2 className="title">Contact Me</h2>
                        </div>
                    </div>
                </div>

                <div className="row mt--50 mt_md--40 mt_sm--40 align-items-center">
                    {/* Left Side: Profile Card */}
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="contact-about-area" style={{ padding: '40px', background: '#fff', borderRadius: '20px', boxShadow: '0 10px 40px rgba(0,0,0,0.08)' }}>
                            <div className="thumbnail mb--30">
                                <img src={contact1} alt="contact-img" style={{ borderRadius: '15px', width: '100%', objectFit: 'cover' }} />
                            </div>
                            <div className="title-area mb--30">
                                <h4 className="title" style={{ fontSize: '32px', marginBottom: '10px' }}>Mukhtar Ahmad Zargar</h4>
                                <span style={{ color: '#ff014f', fontSize: '18px', fontWeight: '500' }}>Software Engineer / Technical Lead</span>
                            </div>
                            <div className="description mb--40">
                                <p style={{ fontSize: '16px', lineHeight: '28px', color: '#666' }}>
                                    I am available for freelance work and consulting. Connect with me via email or phone.
                                </p>
                            </div>
                            <div className="social-area">
                                <div className="name" style={{ fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '20px', color: '#1f1f25' }}>FIND WITH ME</div>
                                <div className="social-share-style-1">
                                    <ul className="social-share d-flex liststyle gap-3">
                                        <li className="instagram" style={{ margin: 0 }}>
                                            <a href="https://www.instagram.com/maaan_g/" target="_blank" rel="noopener noreferrer" style={{ width: '50px', height: '50px', lineHeight: '50px', border: '1px solid #eee', borderRadius: '50%' }}>
                                                <img src={instagram_icon} style={{ width: '20px' }} alt="Instagram" />
                                            </a>
                                        </li>
                                        <li className="linkedin" style={{ margin: 0 }}>
                                            <a href="https://www.linkedin.com/in/mukhtar-ahmad-zargar/" target="_blank" rel="noopener noreferrer" style={{ width: '50px', height: '50px', lineHeight: '50px', border: '1px solid #eee', borderRadius: '50%' }}>
                                                <img src={linked_in_icon} style={{ width: '20px' }} alt="LinkedIn" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Contact Details */}
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                        <div className="contact-info-wrapper">

                            {/* Phone Card */}
                            <div className="contact-card" style={{ padding: '30px', background: '#f8f9fc', borderRadius: '15px', marginBottom: '30px', transition: '0.3s' }}>
                                <div className="icon mb--20" style={{ color: '#ff014f' }}>
                                    <i className="feather-phone" style={{ fontSize: '30px' }}></i>
                                </div>
                                <h5 className="title" style={{ marginBottom: '15px', fontSize: '20px' }}>Phone & WhatsApp</h5>
                                <a href="https://wa.me/917889378278" target="_blank" rel="noopener noreferrer" style={{ fontSize: '24px', fontWeight: '600', color: '#1f1f25', display: 'block', transition: '0.3s' }} className="hover-color">
                                    +91-78893-78278
                                </a>
                            </div>

                            {/* Email Card */}
                            <div className="contact-card" style={{ padding: '30px', background: '#f8f9fc', borderRadius: '15px', marginBottom: '30px', transition: '0.3s' }}>
                                <div className="icon mb--20" style={{ color: '#ff014f' }}>
                                    <i className="feather-mail" style={{ fontSize: '30px' }}></i>
                                </div>
                                <h5 className="title" style={{ marginBottom: '15px', fontSize: '20px' }}>Email</h5>
                                <div className="emails d-flex flex-column gap-2">
                                    <a href="mailto:me@mukhtarzargar.com" style={{ fontSize: '18px', fontWeight: '500', color: '#1f1f25' }} className="hover-color">
                                        me@mukhtarzargar.com
                                    </a>
                                    <a href="mailto:mukhtar@jobspri.com" style={{ fontSize: '18px', fontWeight: '500', color: '#1f1f25' }} className="hover-color">
                                        mukhtar@jobspri.com
                                    </a>
                                </div>
                            </div>

                            {/* Location Card */}
                            <div className="contact-card" style={{ padding: '30px', background: '#f8f9fc', borderRadius: '15px', transition: '0.3s' }}>
                                <div className="icon mb--20" style={{ color: '#ff014f' }}>
                                    <i className="feather-map-pin" style={{ fontSize: '30px' }}></i>
                                </div>
                                <h5 className="title" style={{ marginBottom: '15px', fontSize: '20px' }}>Location</h5>
                                <p style={{ fontSize: '18px', fontWeight: '500', color: '#1f1f25', margin: 0 }}>
                                    Srinagar, Jammu & Kashmir, India
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .hover-color:hover {
                    color: #ff014f !important;
                }
                .contact-card:hover {
                    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
                    transform: translateY(-5px);
                    background: #fff !important;
                }
            `}</style>
        </div>
    );
}

export default Contact;
